import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const AdminPage = lazy(() => import('@/pages/admin/AdminPage'))
const AdminAddPage = lazy(() => import('@/pages/admin/AdminAddPage'))
const AdminDetailPage = lazy(() => import('@/pages/admin/AdminDetailPage'))

/**
 * 관리자 관리 라우트
 * children 없이 flat하게 구성 → 사이드바에 화살표 안 나타남
 */
export const adminRoutes: RouteWithMeta[] = [
  {
    path: 'admin',
    element: withSuspense(<AdminPage/>),
    meta: {
      label: '관리자',
      showInMenu: true,
      icon: ''
    }
  },
  {
    path: 'admin/add',
    element: withSuspense(<AdminAddPage/>),
    meta: {
      label: '관리자 등록',
      showInMenu: false,
    }
  },
  {
    path: 'admin/:id',
    element: withSuspense(<AdminDetailPage/>),
    meta: {
      label: '관리자 상세',
      showInMenu: false
    }
  },
]